import { jwtDecode } from "jwt-decode";

 export function isTokenExpired(token: string): boolean {
   if (!token) return true;

   try {
     const decoded: any = jwtDecode(token);
     const now = Math.floor(Date.now() / 1000);
     return decoded.exp && decoded.exp < now;
   } catch (error) {
     console.error('Error decoding token:', error);
     return true; // Treat as expired if there's an error
   }
 }
